import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { Environments } from "~app/common/models/constants";
import { environment } from "~environments/environment";

@Component({
    selector: "rask-environment-ribbon",
    templateUrl: "./environment-ribbon.component.html",
    styleUrls: ["./environment-ribbon.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe]
})
export class EnvironmentRibbonComponent {
    protected readonly isVisible = signal(environment.environment !== Environments.Prod);
    protected readonly environment = signal(environment.environment);

    ribbonClicked(event: MouseEvent) {
        event.preventDefault();
        this.isVisible.set(false);
    }
}
